module.exports = __webpack_public_path__ + "img/amen.358c5629.png";